// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","5600":"05f6971a","9777":"recorder"}[chunkId] || chunkId) + "." + {"12":"3544a7419181bac2","4762":"f80fe308817188e0","5600":"b73f1868ba2fa7a4","9777":"d68b48fa574eea93"}[chunkId] + ".js";
};